var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _ellipse37, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 779,
    viewBox: "0 0 754 779",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.518 670.095C328.482 668.482 314.371 665.473 300.213 661.286C286.055 657.1 272.206 651.842 259.677 645.895L266.573 643.032C277.16 648.057 288.862 652.5 300.826 656.038C312.79 659.575 324.715 662.119 335.73 663.482L341.518 670.095Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M492.954 652.61C480.907 658.036 467.256 662.817 452.995 666.606C438.733 670.394 424.221 673.095 410.517 674.51L415.091 668.428C426.672 667.232 438.935 664.95 450.986 661.749C463.037 658.547 474.573 654.507 484.753 649.922L492.954 652.61Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.332 109.777C344.323 107.812 358.701 106.904 373.419 107.121C388.137 107.337 402.823 108.672 416.408 111.028L410.465 115.656C398.985 113.665 386.575 112.537 374.138 112.355C361.701 112.172 349.551 112.939 338.573 114.599L331.332 109.777Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_70_62)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 306.572,
    cy: 318.804,
    rx: 306.572,
    ry: 318.804,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 64 77.5244)",
    fill: "#22EAEA",
    fillOpacity: 0.08
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M618.793 384.166C621.626 523.037 515.668 638.003 382.13 640.949C248.592 643.895 138.041 533.706 135.208 394.835C132.375 255.963 238.332 140.997 371.871 138.051C505.409 135.105 615.96 245.294 618.793 384.166ZM146.123 394.594C148.828 527.196 254.389 632.411 381.898 629.597C509.408 626.784 610.583 517.009 607.877 384.407C605.172 251.804 499.612 146.59 372.102 149.403C244.593 152.216 143.418 261.992 146.123 394.594Z",
    fill: "#22EAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M123.988 488.059C119.429 475.257 115.574 460.823 112.706 445.809C109.838 430.796 108.029 415.58 107.409 401.273L113.002 406.351C113.526 418.441 115.055 431.299 117.478 443.986C119.902 456.673 123.159 468.87 127.012 479.688L123.988 488.059Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M205.219 612.006C194.999 603.437 184.582 593.091 174.726 581.722C164.87 570.353 155.824 558.248 148.247 546.288L155.551 547.672C161.954 557.778 169.598 568.008 177.927 577.615C186.255 587.222 195.058 595.965 203.694 603.205L205.219 612.006Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M597.047 569.136C588.653 579.632 578.547 590.307 567.466 600.383C556.385 610.458 544.608 619.68 532.994 627.377L534.436 619.803C544.25 613.299 554.202 605.506 563.566 596.992C572.929 588.478 581.469 579.457 588.562 570.587L597.047 569.136Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M652.585 452.218C649.666 465.528 645.297 479.803 639.798 494.002C634.299 508.201 627.809 521.966 620.799 534.294L618.79 526.861C624.713 516.443 630.198 504.811 634.845 492.813C639.491 480.814 643.183 468.752 645.65 457.504L652.585 452.218Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M643.485 314.617C646.631 327.871 648.899 342.664 650.125 357.918C651.351 373.172 651.503 388.502 650.571 402.792L645.563 397.092C646.35 385.017 646.222 372.062 645.186 359.172C644.15 346.282 642.233 333.781 639.575 322.581L643.485 314.617Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M589.359 186.995C597.524 197.685 605.507 210.154 612.727 223.493C619.947 236.832 626.222 250.705 631.093 264.102L624.258 261.086C620.141 249.766 614.839 238.043 608.738 226.771C602.637 215.499 595.891 204.962 588.991 195.929L589.359 186.995Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M472.879 124.552C485.323 128.9 498.545 134.843 511.583 141.948C524.62 149.054 537.144 157.142 548.241 165.624L540.929 166.963C531.551 159.795 520.968 152.96 509.951 146.956C498.934 140.951 487.761 135.929 477.245 132.255L472.879 124.552Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M109.942 324.509C112.925 311.215 117.362 296.963 122.929 282.793C128.496 268.623 135.052 254.891 142.121 242.6L144.095 250.043C138.122 260.43 132.581 272.033 127.877 284.007C123.173 295.982 119.423 308.025 116.902 319.259L109.942 324.509Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.734 176.245C205.569 167.203 217.123 158.257 229.552 150.057C241.982 141.858 254.974 134.612 267.581 128.848L265.045 136.105C254.392 140.976 243.413 147.098 232.91 154.027C222.406 160.956 212.643 168.516 204.332 176.157L195.734 176.245Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 284.803 178.947)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 251.833 199.516)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 320.003 167.541)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 358.74 162.435)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 398.925 161.548)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 437.283 171.331)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 468.237 185.529)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 496.566 204.746)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 519.433 223.374)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 539.648 245.604)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 555.848 271.466)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 570.005 297.373)",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 578.771 326.233)",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 584.247 360.835)",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 585.055 400.5)",
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 580.416 440.285)",
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 568.212 476.694)",
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 549.776 508.281)",
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 533.24 532.739)",
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 510.56 556.624)",
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 483.038 577.072)",
    fill: "white"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 452.677 591.915)",
    fill: "white"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 417.477 603.321)",
    fill: "white"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 381.479 609.075)",
    fill: "white"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 341.193 605.004)",
    fill: "white"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 303.515 595.206)",
    fill: "white"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 267.751 578.987)",
    fill: "white"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 238.725 559.078)",
    fill: "white"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 213.686 534.12)",
    fill: "white"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 191.964 504.837)",
    fill: "white"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 172.809 467.702)",
    fill: "white"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 161.682 423.305)",
    fill: "white"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 156.729 380.896)",
    fill: "white"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 161.31 338.277)",
    fill: "white"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 174.775 296.88)",
    fill: "white"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 194.5 261.723)",
    fill: "white"
  })), _ellipse37 || (_ellipse37 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.10954,
    cy: 5.31341,
    rx: 5.10954,
    ry: 5.31341,
    transform: "matrix(0.999757 -0.0220567 0.0203959 0.999792 219.022 227.876)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_70_62",
    x: 0.432129,
    y: 0.689453,
    width: 753.136,
    height: 777.622,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_70_62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup15);
export default __webpack_public_path__ + "static/media/Group 15.bb069febe0e1e3db9b8d43cefa513844.svg";
export { ForwardRef as ReactComponent };